import React from "react";
// import Alert from "react-bootstrap/Alert";
import { Container } from "react-bootstrap";
import HelmetWrapper from "../../HelmetWrapper";
import Notifications from "../push-notifications/Notifications";
import ExpenseRequestsLanding from "./ExpenseRequestsLanding";
import WelcomeUser from "../Open-pages/user/WelcomeUser";
import "../../styles/expense-management/expense-management.css";

const ExpenseRequests = ({
  userInfoData,
  isCustom,
  isIOS,
  // isNotificationDenied,
}) => {
  return (
    <HelmetWrapper title="WTF: Expense Management">
      <Container className="bg-cloud-k px-50px gobal-container" fluid>
        {isCustom && (
          <div className="mt30">
            <WelcomeUser userName={userInfoData?.name} />

            {userInfoData && !isIOS() && (
              <Notifications authData={userInfoData} />
            )}

            {/* {isNotificationDenied === "denied" && (
              <Alert variant={"danger"} className="mt30">
                Notification permission is denied. Unable to display desktop
                notifications.
              </Alert>
            )} */}
          </div>
        )}

        <ExpenseRequestsLanding
          userInfoData={userInfoData}
          isCustom={isCustom}
          isIOS={isIOS}
          // isNotificationDenied={isNotificationDenied}
        />
      </Container>
    </HelmetWrapper>
  );
};

export default ExpenseRequests;
